import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const platformLinks = [{
    name: 'Cursos',
    href: '#cursos'
  }, {
    name: 'Alice App',
    href: '#alice-app'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  const legalLinks = [{
    name: 'Soporte',
    href: '#'
  }, {
    name: 'Términos',
    href: '#'
  }, {
    name: 'Privacidad',
    href: '#'
  }];
  return <footer className="bg-link-dark text-white pt-10 pb-6" data-id="element-94">
      <div className="container mx-auto px-4 md:px-6" data-id="element-95">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-8" data-id="element-96">
          {/* Brand */}
          <div className="md:max-w-sm" data-id="element-97">
            <Logo dark className="mb-3" data-id="element-98" />
            <p className="text-gray-400 leading-relaxed text-sm" data-id="element-99">
              Link Academy: aprende marketing digital, aplica inteligencia
              artificial y construye estrategias que funcionan.
            </p>
          </div>

          {/* Inline Links */}
          <div className="flex flex-wrap gap-x-8 gap-y-3 md:items-center" data-id="element-100">
            {[...platformLinks, ...legalLinks].map(link => <a key={link.name} href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-101">
                {link.name}
              </a>)}
          </div>
        </div>

        <div className="border-t border-gray-800 pt-5 flex flex-col md:flex-row justify-between items-center gap-2" data-id="element-102">
          <p className="text-gray-500 text-xs" data-id="element-103">
            © {currentYear} Link Academy. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}